import { __assign } from '../../../_virtual/_tslib.js';
import React, { Suspense } from 'react';

var LikedByMembersListModal = React.lazy(function () { return import('./LikedByMembersListModal.js'); });
var LazyLoadedLikedByMembersListModal = function (props) {
    var isOpen = props.isOpen;
    if (!isOpen)
        return null;
    return (React.createElement(Suspense, { fallback: null },
        React.createElement(LikedByMembersListModal, __assign({}, props))));
};

export { LazyLoadedLikedByMembersListModal as default };
//# sourceMappingURL=LazyLoadedLikedByMembersListModal.js.map
